/** Angular */
import { Injectable } from '@angular/core';

@Injectable()
export class CheckboxSelectUtilsService {

	public allChecked: boolean = false;
	public allUnpagedChecked: boolean = false;
	public selectedIdsList: number[] = [];
	public array: any[] = [];
	public totalItems: number = 0;
	public idProp: string = 'id';

	/**
	 * Handles selecting an item's checkbox and storing it in selectedList
	 *
	 * @param item: any
	 * @param e: mat-checkbox event
	 */
	itemCheck(item: any, e): void {
        if (e.checked) {
            if(!this.selectedIdsList.includes(item[this.idProp])) this.selectedIdsList.push(item[this.idProp]);
			item.selected = true;
			if(!this.array.some(item => !item.selected)) this.allChecked = true;
        } else {
            if (this.selectedIdsList.includes(item[this.idProp])) {
                const i = this.selectedIdsList.indexOf(item[this.idProp]);
                this.selectedIdsList.splice(i, 1);
            }
			item.selected = false;
			this.allChecked = false;
			this.uncheckAllUnpaged();
        }
    }

	/**
	 * Handles selecting an item's checkbox and storing it in selectedList
	 *
	 * @param e: mat-checkbox event
	 */
    checkAll(e): void {
        if (e.checked) {
            this.allChecked = true;
            this.array.map(item => {
                item.selected = true;
				if(!this.selectedIdsList.includes(item[this.idProp])) this.selectedIdsList.push(item[this.idProp]);
            });
        } else {
            this.allChecked = false;
            this.array.map(item => {
                item.selected = false;
                this.selectedIdsList = [];
            });
			this.uncheckAllUnpaged();
        }
    }

	/**
	 * Returns a boolean for checking if all items are shown on page or not
	 *
	 */
	areAllItemsOnOnePage(): boolean {
		if(this.array.length > this.totalItems) {
			console.error('Something went wrong. Array larger than total');
			return;
		}
		return this.array.length && this.array.length === this.totalItems;
	}

	/**
	 * Sets the array data
	 *
	 * @param array: array of items
	 */
	onArrayUpdate(array: any[]): void {
		this.array = [...array];
		let areAllItemsSelected = true;

		for(let item of this.array) {
			if(this.selectedIdsList.includes(item[this.idProp])) item.selected = true;
			else areAllItemsSelected = false;
		}

		if(!this.array.length) areAllItemsSelected = false;

		this.allChecked = this.allUnpagedChecked ? false : areAllItemsSelected;
	}

	/**
	 * Resets current selection of items
	 */
	resetCurrentSelection(): void {
		this.allChecked = false;
		this.selectedIdsList = [];
		for(let item of this.array) item.selected = false;
	}

	/**
	 * Selects all items, in current page and those that aren't
	 *
	 */
	checkAllUnpaged(): void {
        this.allUnpagedChecked = true;
		this.resetCurrentSelection();
    }

	/**
	 * Unselects all items, in current page and those that aren't
	 *
	 */
	uncheckAllUnpaged(): void {
        this.allUnpagedChecked = false;
    }

	/**
	 * Unselects all items, in current page and those that aren't
	 *
	 */
	resetClass(): void {
        this.allChecked = false;
		this.allUnpagedChecked = false;
		this.selectedIdsList = [];
		this.array = [];
		this.totalItems = 0;
		this.idProp = 'id';
    }
}
